<template>
  <div class="Login">
    <div class="Login_form">
      <div class="user">
        <img src="../assets/img/login/user.png" alt="" />
        <input type="text" placeholder="Username" v-model="username" />
      </div>

      <div class="password">
        <img src="../assets/img/login/passWard.png" alt="" />
        <input
          type="password"
          placeholder="Please enter password"
          oncut="return false"
          onpaste="return false"
          oncopy="return false"
          v-model="password" />
      </div>

      <div class="btn">
        <div class="Confirm" @click="Confirm">Confirm</div>
        <div class="Cancel" @click="Cancel">Cancel</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: ''
    };
  },
  methods: {
    Confirm() {
      if (btoa(this.username) == window.streamingConfig.username && btoa(this.password) === window.streamingConfig.password) {
        let info = {
          username: btoa(this.username),
          password: btoa(this.password)
        };
        sessionStorage.setItem('userInfo', JSON.stringify(info));
        //this.$store.commit('setUserInfo', info)
        this.$router.push({ path: '/protDistribution' });
      } else {
        this.$message.error('Wrong username or password');
      }
    },
    Cancel() {
      this.username = '';
      this.password = '';
    }
  },

  mounted() {}
};
</script>

<style lang="less" scoped>
.Login {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('../assets/img/login/bg.jpg') no-repeat 100%;
  z-index: 2023;
  pointer-events: all;

  .Login_form {
    position: absolute;
    width: 1096px;
    height: 632px;
    top: 49%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 105px 65px 0px;
    box-sizing: border-box;
    z-index: 2024;
    background: url('../assets/img/login/form.png') no-repeat 100%;

    .user,
    .password {
      width: 100%;
      height: 65px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-image: url('../assets/img/login/line.png');
      background-size: 944px 4px;
      background-repeat: no-repeat;
      background-position: bottom center;

      & > input {
        width: calc(100% - 66px);
        height: 65px;
        border: none;
        background: transparent;
        color: #aaaaaa;
        font-size: 40px;
        font-family: '微软雅黑';
      }
    }

    .password {
      margin-top: 79px;
    }

    .btn {
      margin-top: 102px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 120px;

      .Confirm {
        width: 414px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        background-color: #296fd6;
        color: #fff;
        font-size: 40px;
        font-family: '微软雅黑';
        border-radius: 10px;
        cursor: pointer;
      }

      .Cancel {
        width: 414px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        background-color: #0e3264;
        border: solid 1px #296fd6;
        color: #fff;
        font-size: 40px;
        font-family: '微软雅黑';
        border-radius: 10px;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
  }
}
</style>
